export const cardLoyaltyProgramExternal = {
    targetClientId: '',
};
